import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useState, useEffect } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import ExampleComponent from '../ExampleComponent'
import StoryMenu from '../StoryMenu'
import Sponsors from '../Sponsors'
import Title from '../Title'

const defaultProperties: { [key: string]: string } = {
  module: 'menu',
  titleText: "Ce qu'on sait des causes du Covid long",
  titleSub: 'Le Covid long, c’est quoi ?',
  titleId: '0',
  menuEntries:
    '["Lorem ipsum", "La fatigue à l’effort: quand le système nerveux autonome dysfonctionne", "Title"]',
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [elements, setElements] = useState<any>({})
  const theme = {
    purpleBright: '#BA7FB7',
    purpleMain: '#A757A3',
    purpleDark: '#7A3F77',
    purpleDarker: '#512A4F',
    colorMode: colorMode,
    grayLight: '#f8f9fc',
    grayMain: '#f1f3f9',
    grayDark: colorMode === 'dark' ? '#373739' : '#dee3ed',
    tenantColor: colorMode === 'dark' ? '#f4f4f4' : `var(--tenant-${tenant?.key.slice(0, 3)})`,
    textColor: colorMode === 'dark' ? '#f4f4f4' : '#121212',
  }

  createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Suez+One&display=swap');
  `

  const modules: { [key: string]: ReactElement } = {
    symptoms: (
      <SymptomsContainer>
        <AppContent>
          <ExampleComponent lang={tenant?.lang} />
        </AppContent>
      </SymptomsContainer>
    ),
    menu: (
      <StoryMenu
        elementsRefs={elements}
        elements={JSON.parse(properties.menuEntries || '[]')}
        color={properties.color}
      />
    ),
    title: (
      <Title
        anim={properties.titleAnim}
        text={properties.titleText}
        sub={properties.titleSub}
        id={properties.titleId}
        color={properties.color}
      />
    ),
    sponsors: <Sponsors />,
  }

  const handleTest = (e: any) => {
    const el = elements
    el[e.detail.id] = e.detail.data
    setElements(el)
  }

  useEffect(() => {
    window.addEventListener('test', handleTest)

    return () => {
      window.removeEventListener('test', handleTest)
    }
  }, [])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ThemeProvider theme={theme}>
        {properties?.module && modules[properties.module]}
      </ThemeProvider>
    </AppContainer>
  )
}

const SymptomsContainer = styled.div`
  min-height: 120vh;
  background-color: ${({ theme }) =>
    theme.colorMode === 'dark' ? '#121212' : '#ffffff'}};
  position: relative;
  margin-bottom: 0px;
`

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const AppContent = styled.div`
  height: 100vh;
  position: sticky;
  top: 0;
  left: 0;
`

export default MainComponent
